export var headers = {
  Accept: "application/json",
  "Content-Type": "application/json"
};
export var formHeaders = {
  Accept: "application/json",
  "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
};